let host = ''
function formPostData (json) {
  var array = []
  for (var key in json) {
    let val = json[key]
    if (val == null || val === undefined) {
      val = ''
    }
    array.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
  }
  return array.join('&')
}
export { host, formPostData }



// WEBPACK FOOTER //
// ./src/api/base.api.js